module.exports = __webpack_public_path__ + "img/talkicon2.25194085.png";